import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import Preview from 'HOC/withPreview/Preview';

// import { getObjectDownload } from 'api/actions';

import { url } from 'utils';

class ViewFile extends React.Component {
	state = {
		search: ''
	}

	componentWillMount() {
		this.loadFile(this.props);
	}

	componentWillReceiveProps(nextProps) {
		const refresh = this.state.search !== nextProps.location.search;

		if (refresh) {
			this.loadFile(nextProps);

			this.setState({ search: nextProps.location.search })
		}
	}

	loadFile = (props) => {
		const id = url.getParam(props, 'id');

		// if (id) this.props.getObjectDownload({ id });	
	}

	render() {
		return(
			<div style={{ position: 'relative', height: '100%', marginTop: 15 }}>
				<Preview relative hideNavbar lightTheme />
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
  type: state.type,
});

// const dispatchToProps = (dispatch) => {
//   return bindActionCreators({ getObjectDownload }, dispatch)
// };


export default connect(mapStateToProps)(withRouter(ViewFile));
